import { createFileRoute, useSearch } from '@tanstack/react-router'
import type { JSX } from 'react'

import { DashboardScreen } from './-components/dashboard-screen.tsx'

/**
 * One Studio TV dashboard. The document is the `id` search param, read loosely
 * so a typed `validateSearch` does not narrow every `navigate` call in the app.
 */
export const Route = createFileRoute('/studio/dashboard')({
  component: DashboardPage
})

function DashboardPage(): JSX.Element {
  const search: Record<string, unknown> = useSearch({ strict: false })
  const id =
    typeof search.id === 'string' && search.id !== '' ? search.id : null
  return <DashboardScreen key={id ?? 'none'} id={id} />
}
